module.exports = __webpack_public_path__ + "img/9_53.c206627f.png";